import { render, staticRenderFns } from "./peopleEdit.vue?vue&type=template&id=4804fd41&"
import script from "./peopleEdit.vue?vue&type=script&lang=ts&"
export * from "./peopleEdit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports